<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="title"
      visible
      :size="1200"
      show-close
      @close="close"
      append-to-body
    >
      <div>
        <FabricColorTable :tableHeight="500" @chooseFabric="chooseFabric" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import FabricColorTable from './table.vue'
import EditLoading from '@/mixins/edit-loading'

export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '选择面料' },
  },
  mixins: [EditLoading],
  components: { FabricColorTable },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    chooseFabric(fabric) {
      this.close()
      this.$emit('chooseFabric', fabric)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
